import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid, CircularProgress, Drawer } from '@material-ui/core';
import { portalCfg } from '../../../portal.router.config';
import { CameraIcon, FemaleIcon, MaleIcon, EditIcon, PlaceActiveIcon, PlaceBlackIcon, AddressIcon, CheckIcon, DeleteWhiteIcon } from '../../components/icons'
import { Field, Form } from 'react-final-form';
import validators from '../../utils/validators';
import { TextFieldComponent, DatePickerComponent, TextFieldWithSelectComponent, Select2Component, SelectComponent } from '../../components/FormElement';
import Button from '../../components/ButtonCustom';
import { toDateDDMMYYYY, createFulltMonth, createDayObj } from '../../utils/util'
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';

import Modal from '../../components/Modal';
import { dataUtil, preferences_type } from '../../wsclient/crmservices/dataUtil';
import countries from '../../../countries';
import Typo from '../../components/CustomTypo';
import DividerCustom from '../../components/Divider';
import { defaultCustomfield_types, domainName } from '../../../portal.config';
const defaultProfile = portalCfg.publicPath + "/assets/images/default-profile.png";
const styles = theme => ({
    btn_save: {
        marginTop: theme.spacing(8),
    },
    btn_address: {
        padding: theme.spacing(3, 1, 3, 1),
    },
    image_profile_container: {
        padding: theme.spacing(2),
        width: 105,
        height: 105,
        borderColor: 'transparent',
        position: 'relative',
        cursor: 'pointer',

    },
    image_profile: {
        width: 88,
        height: 88,
        borderRadius: 88,
        resizeMode: 'contain',
    },
    icon_container: {
        position: 'absolute',
        bottom: 10,
        right: 0,
        width: 32,
        height: 32,
        borderRadius: 32,
        borderWidth: 1,
        borderColor: 'transparent',
        backgroundColor: theme.palette.primary.main,
        alignItems: 'center',
        justifyContent: 'center'
    },
    form_password: {
        position: 'relative',
        alignItems: 'center',
    },
    edit_password: {
        position: 'absolute',
        right: 20,
        bottom: 20,
        cursor: 'pointer'
    },
    button_gender_container: {
        padding: theme.spacing(1)
    },
    button_gender: {
        //padding: theme.spacing(1),
        height: theme.spacing(12),
        width: '100%',
        borderRadius: 32,
        ...theme.palette.button.light,
        cursor: 'pointer'
    },
    button_gender_active: {
        height: theme.spacing(12),
        width: '100%',
        borderRadius: 32,
        ...theme.palette.button.primary,
        cursor: 'pointer'
    },
    inputContainer: {
        border: '1px solid',
        borderColor: theme.palette.border.secondary,
        borderRadius: 24,
        height: 48,
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.secondary,
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        marginTop: theme.spacing(1),
        cursor: 'pointer'
    },
    method_container: {
        padding: theme.spacing(4, 0, 0, 0)
    },
    method_pre: {
        padding: theme.spacing(0, 2, 0, 0)
    },
    method: {
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(2),
        padding: theme.spacing(4, 4, 4, 4),
        cursor: 'pointer',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
        }
    },
    bg_icon: {
        width: theme.spacing(6),
        height: theme.spacing(6),
        borderRadius: theme.spacing(6),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.icon.trash,
        cursor: "pointer",
        touchAction: "manipulation",
    },
    button_add: {
        justifyContent: 'flex-end',
    },
});
function MyProfileView(props) {
    console.log("AAAA MyProfileView props: ", props)
    const formatNameDay = (value) => {
        var day = value.day;
        var month = value.month;
        if (day < 10) day = '0' + day;
        month = createFulltMonth()[month - 1];
        return day + " " + month;
    }
    const formatListNameDay = (list) => {
        list.forEach((date) => {
            let label = formatNameDay(date)
            date.label = label
            date.value = date.day + '/' + date.month
        })
        return list;
    }

    const { classes, t, auth_support, features, onOpenAddress, addresses } = props
    const { profile, profile_demographics, profile_phone, showLoading, onSubmit, onOpenChangePassword, onSelectCountry, country_code, onChangeGender, onSelectNameDay, customfieldTypes, customfield, onSelectMethod } = props;
    var dateOfBirth = null;
    var dob = profile_demographics.date_of_birth;
    console.log('dob========', dob)

    if (dob && dob.year && dob.month && dob.day) {
        dateOfBirth = toDateDDMMYYYY(dob);
    } else {
        dateOfBirth = "DD/MM/YYYY";
    }
    console.log('dateOfBirth========', dateOfBirth)

    var nameday = null
    var list_nameday = formatListNameDay(props.list_nameday);

    if (profile_demographics.name_day) {
        nameday = profile_demographics.name_day.day + "/" + profile_demographics.name_day.month
        // list_nameday = this.checkNameDay(profile_demographics.name_day, list_nameday)
    }
    //var nameday_string = profile_demographics.name_day && profile_demographics.name_day.day && profile_demographics.name_day.month ? this.formatNameDay(profile_demographics.name_day) : "DD/MM";



    var gender = profile_demographics.gender;
    //features.ordering_details.preferred_organisation_orders = false
    //features.rewards_details.preferred_organisation_rewards = true
    var isAuthByEmail = auth_support && (auth_support.email_password || auth_support.email_otp);
    var isAuthByPhone = auth_support && auth_support.sms_otp;
    console.log("profile_demographics==", profile_demographics);
    return (
        <div>
            <DrawerCustom
                open={props.open}
                onClose={() => props.handleDrawerToggle('my_profile')}
                title={t('Edit Profile')}
                children={
                    <Grid xs={12} item justify='center'>

                        <Grid item container justify='center'>
                            <Grid item className={classes.image_profile_container}>
                                <img className={classes.image_profile} src={defaultProfile} />
                                {/* <Grid className={classes.icon_container} item container>
                                        <CameraIcon/>
                                    </Grid> */}
                            </Grid>
                            {showLoading && <Grid xs={12} item container justify='center'>
                                <CustomizedCircularProgress />
                            </Grid>}
                            <Form
                                onSubmit={onSubmit}
                                render={({ handleSubmit, reset, submitting, pristine, values }) => (
                                    <Grid xs={12} container item justify='center'>
                                        <Grid xs={12} item container>
                                            <Field
                                                name="first_name"
                                                component={TextFieldComponent}
                                                label={t('first_name')}
                                                defaultValue={profile.first_name}
                                                placeholder={t('enter_your_firstname')}
                                                isEdit={true}
                                                color='default'
                                                validate={validators.composeValidators(validators.required)}
                                            />
                                        </Grid>
                                        <Grid xs={12} item container >
                                            <Field
                                                name="last_name"
                                                component={TextFieldComponent}
                                                label={t('last_name')}
                                                defaultValue={profile.last_name}
                                                placeholder={t('enter_your_lastname')}
                                                isEdit={true}
                                                color='default'
                                                validate={validators.composeValidators(validators.required)}
                                            />
                                        </Grid>
                                        {domainName == 'airlink' && <>
                                            <Grid xs={12} item container >
                                                <Field
                                                    name="id_number"
                                                    component={TextFieldComponent}
                                                    label={t('id_number')}
                                                    placeholder={t('enter_id_number')}
                                                    isEdit={true}
                                                    color='default'
                                                    defaultValue={profile_demographics.id_details && profile_demographics.id_details.id_number ? profile_demographics.id_details.id_number : null}
                                                    valuez={profile_demographics.id_details && profile_demographics.id_details.id_number ? profile_demographics.id_details.id_number : null}
                                                />
                                            </Grid>
                                            <Grid xs={12} item container >
                                                <Field
                                                    name="passport_number"
                                                    component={TextFieldComponent}
                                                    label={t('passport_number')}
                                                    placeholder={t('enter_passport_number')}
                                                    isEdit={true}
                                                    color='default'
                                                    defaultValue={profile_demographics.passport && profile_demographics.passport.passport_number ? profile_demographics.passport.passport_number : null}
                                                    valuez={profile_demographics.passport && profile_demographics.passport.passport_number ? profile_demographics.passport.passport_number : null}
                                                />
                                            </Grid>
                                            <Grid xs={12} item container >
                                                <Field
                                                    name="statutory_number"
                                                    component={TextFieldComponent}
                                                    label={t('statutory_number')}
                                                    placeholder={t('enter_statutory_number')}
                                                    isEdit={true}
                                                    color='default'
                                                    defaultValue={profile.statutory_number}
                                                />
                                            </Grid>
                                        </>}
                                        <Grid xs={12} item container>
                                            <Field
                                                name="email_address"
                                                component={TextFieldComponent}
                                                label={t('email')}
                                                defaultValue={profile.email}
                                                placeholder={t('email_input_placeholder')}
                                                isEdit={isAuthByEmail ? false : true}
                                                color='default'
                                                validate={validators.composeValidators(validators.required)}
                                            />
                                        </Grid>
                                        <Grid xs={12} item container>
                                            <Field
                                                name="phone"
                                                component={TextFieldWithSelectComponent}
                                                label={t('phone_number')}
                                                isEdit={isAuthByPhone ? false : true}
                                                color='default'
                                                defaultValue={profile_phone.number}
                                                validate={validators.composeValidators(validators.mustBeNumber)}
                                                autoFocus={true}
                                                selectData={countries}
                                                defaultValueSelect={props.country_select}
                                                valueSelect={props.country_select}
                                                onSelectedChange={onSelectCountry}
                                            //disableEndAdornment
                                            />
                                        </Grid>
                                        {props.isLoadedPreferred && props.preferredCommunicationMethods && props.preferredCommunicationMethods.length > 0 && <Grid xs={12} item container>
                                            <Field
                                                name="preferred_communication_method"
                                                component={SelectComponent}
                                                label={t('Preferred Communication Method')}
                                                selectData={props.preferredCommunicationMethods}
                                                defaultValueSelect={props.preferredCommunicationMethod && props.preferredCommunicationMethod.value}
                                                valueSelect={props.preferredCommunicationMethod && props.preferredCommunicationMethod.value}
                                                onSelectedChange={(event)=>onSelectMethod(event.target.value)}
                                                color='default'
                                                isEdit={true}
                                            />
                                        </Grid>}
                                        {props.is_supported_gender && <Grid xs={12} item container>
                                            <Typo mg_left_md mg_top_sm color='default' variant="input_label">{t('gender')}</Typo>
                                        </Grid>}
                                        {props.is_supported_gender && <Grid xs={12} item container direction='row' justify='flex-start'>
                                            <Grid xs={6} sm={3} item container justify='center' className={classes.button_gender_container} onClick={() => onChangeGender("MALE")}>
                                                <Grid item className={gender === 'MALE' ? classes.button_gender_active : classes.button_gender} container justify='center' alignItems='center' >
                                                    {/* <MaleIcon /> */}
                                                    <Typo mg_left_xs >{t('male')}</Typo>
                                                </Grid>
                                            </Grid>
                                            <Grid xs={6} sm={3} item container justify='center' className={classes.button_gender_container} onClick={() => onChangeGender("FEMALE")}>
                                                <Grid item className={gender === 'FEMALE' ? classes.button_gender_active : classes.button_gender} container justify='center' alignItems='center' >
                                                    {/* <FemaleIcon/> */}
                                                    <Typo mg_left_xs >{t('female')}</Typo>
                                                </Grid>
                                            </Grid>
                                        </Grid>}
                                        {props.is_supported_dob && <Grid xs={12} item container>
                                            <Field
                                                name="date_of_birth"
                                                component={DatePickerComponent}
                                                label={t('date_of_birth')}
                                                isEdit={props.isEditDOB}
                                                color='default'
                                                valuez={dateOfBirth}
                                            //value={dateOfBirth}
                                            />
                                        </Grid>}
                                        {props.is_supported_nameday && <Grid xs={12} item container>
                                            {/* <Typo mg_top_sm mg_left_md variant='input_label' color='default'>{t('name_day')}</Typo>
                                                <Grid xs={12} item container className={classes.inputContainer} alignItems='center' onClick={() => this.setState({ showNameDay: !this.state.showNameDay })}>
                                                    <Typo mg_left_md color='primary'>{nameday}</Typo>
                                                </Grid>     */}
                                            {/* <Field
                                                        name="name_day"
                                                        component={Select2Component}
                                                        label={t('name_day')}
                                                        selectData={createDayObj()}
                                                        selectData2={createFulltMonth()}
                                                        valueSelect={profile_demographics.name_day && profile_demographics.name_day.day}
                                                        valueSelect2={profile_demographics.name_day && profile_demographics.name_day.month}
                                                        onSelectedChange={(event) => onSelectNameDay('day', event)}
                                                        onSelectedChange2={(event) => onSelectNameDay('month', event)}
                                                        color='default'
                                                        placeholder={t('Select')}
                                                    /> */}
                                            <Field
                                                name="name_day"
                                                component={SelectComponent}
                                                label={t('name_day')}
                                                selectData={list_nameday}
                                                valueSelect={nameday}
                                                onSelectedChange={(event) => onSelectNameDay(event)}
                                                color='default'
                                                placeholder={t('Select')}
                                                isEdit={!props.isNameDay}
                                            />
                                        </Grid>}

                                        <Grid xs={12} item container style={{ marginTop: 8, marginBottom: 8 }}>
                                            {/* <Button color='primary' variant='body2' size="lg" onClick={onOpenAddress}><AddressIcon/>{t('address_book')}</Button>
                                                   <DividerCustom fullWidth/> */}

                                            {/* <Grid xs={6} sm={4} item container justify='center' className={classes.btn_address} onClick={onOpenAddress}>
                                                <Grid item className={classes.button_gender_active} container alignItems='center' justify='center' >
                                                    <AddressIcon />
                                                    <Typo mg_left_xs >{t('address_book')}</Typo>
                                                </Grid>
                                            </Grid> */}
                                            <Grid item xs={12}>
                                                <Grid item xs={12} container alignItems='center' >
                                                    <Grid item style={{ flex: 1 }}>
                                                        <Typo mg_left_xs color='default'>{t('address_book')}</Typo>
                                                    </Grid>
                                                    <Grid item style={{ flex: 1, textAlign: 'right'}}>
                                                        <Button size='xs' color='primary' className={classes.button_add} onClick={props.onAddAddresses}>{t('new_address_title')}</Button>
                                                    </Grid>
                                                </Grid>
                                                {addresses.length > 0 ? addresses.map((item, index) =>
                                                    <AddressItem key={index} classes={classes} item={item} onRemoveAddress={props.onRemoveAddress} onShowDetail={props.onShowDetailAddress} />)
                                                    : null}
                                            </Grid>
                                        </Grid>



                                        {auth_support && auth_support.email_password && <Grid xs={12} item container className={classes.form_password}>
                                            <Field
                                                name="password"
                                                component={TextFieldComponent}
                                                label={t('password')}
                                                defaultValue={'********'}
                                                isEdit={false}
                                                color='default'
                                                type='password'
                                                autoFocus={true}
                                                disableEndAdornment
                                            />
                                            <EditIcon className={classes.edit_password} onClick={() => onOpenChangePassword()} />

                                        </Grid>}
                                        {features.ordering_details && features.ordering_details.preferred_organisation_orders &&
                                            <PreferredComponent name={"prefered_order"} label={t('prefered_order')} classes={classes}
                                                favourite_shop={dataUtil.filterContactPreferencesByType(props.favourite_shop, preferences_type.order)}
                                                onShowMerchantList={() => props.onShowMerchantList(preferences_type.order)}
                                            />}

                                        {features.rewards_details && features.rewards_details.preferred_organisation_rewards &&
                                            <PreferredComponent name={"prefered_rewards"} label={t('prefered_rewards')} classes={classes}
                                                favourite_shop={dataUtil.filterContactPreferencesByType(props.favourite_shop, preferences_type.rewards)}
                                                onShowMerchantList={() => props.onShowMerchantList(preferences_type.rewards)}
                                            />}
                                        <Grid xs={12} item container justify='center' className={classes.btn_save}>
                                            <Button color='primary' fullWidth onClick={handleSubmit}>{t('btn_save')}</Button>
                                        </Grid>
                                    </Grid>
                                )} 
                            />
                        </Grid>
                    </Grid>}
            />
        </div>
    );
}


function PreferredComponent(props) {
    var { label, favourite_shop, classes, name } = props;
    return (
        <Grid xs={12} item container className={classes.form_password}>
            <Field
                name={name}
                component={TextFieldComponent}
                label={label}
                defaultValue={favourite_shop ? favourite_shop.name : ""}
                isEdit={false}
                color='default'
                disableEndAdornment
            />
            <EditIcon className={classes.edit_password} onClick={props.onShowMerchantList} />
        </Grid>
    )

}

function AddressItem(props) {
    const { classes, onRemoveAddress } = props
    var item = props.item;
    console.log('AddressItem===', item)
    var address = ""
    if (item.address_line_1) {
        address = address + item.address_line_1;
    }
    if (item.address_line_2) {
        address = address + ", " + item.address_line_2;
    }
    if (item.town_city) {
        address = address + ", " + item.town_city;
    }
    return (
        <div>
            <Grid xs={12} item container className={classes.method_container}>
                <Grid xs={11} item className={classes.method_pre}>
                    <Grid item container className={classes.method} onClick={() => props.onShowDetail(item)} alignItems='center'>
                        <Grid xs={4} sm={3} item container alignItems='center'>
                            <Button size="xs" color={"success"}>{item.address_type}</Button>
                        </Grid>
                        <Grid xs={7} sm={8} item container alignItems='center'>
                            <Grid item xs={12}>
                                <Typo variant='subtitle2'>{item.address_name}</Typo>
                            </Grid>
                            <Grid item xs={12}>
                                <Typo variant='body2' color='primary'>{address}</Typo>
                            </Grid>
                        </Grid>
                        {item.is_primary && <Grid xs={1} item container justify='flex-end' >
                            <CheckIcon />
                        </Grid>}
                    </Grid>
                </Grid>
                <Grid xs={1} item container justify='flex-end' alignItems='center'>
                    <div className={classes.bg_icon} onClick={() => onRemoveAddress(item)}>
                        <DeleteWhiteIcon />
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}
export default withStyles(styles)(withTranslation()(MyProfileView));